import {
  menuMatchesRestaurant,
  menuMatchesEnCas,
  menuMatchesPetitDejeuner,
} from "./helpers"

/** @typedef {{ fr?: Record<string, string>, en?: Record<string, string>, ar?: Record<string, string> }} LabelOverrides */

/**
 * @typedef {{
 *   venuesEndpoint: string,
 *   pageContentPageName: string,
 *   reservationService: string,
 *   filterMenu: (menu: object, venueId: string) => boolean,
 *   labelOverrides?: LabelOverrides,
 * }} VenueMenusClientConfig
 */

/** @type {VenueMenusClientConfig} */
export const RESTAURANT_VENUE_CONFIG = {
  venuesEndpoint: "/restaurants",
  pageContentPageName: "Restaurants",
  reservationService: "restaurant",
  filterMenu: menuMatchesRestaurant,
  labelOverrides: {},
}

/** @type {VenueMenusClientConfig} */
export const ENCAS_VENUE_CONFIG = {
  venuesEndpoint: "/en-cas",
  pageContentPageName: "EnCas",
  reservationService: "encas",
  filterMenu: menuMatchesEnCas,
  labelOverrides: {
    fr: {
      loadingRestaurants: "Chargement des en-cas",
      loadingMenus: "Chargement des menus",
      noRestaurantsFound: "Aucun en-cas trouvé",
      comeBackSoonRestaurants: "Revenez bientôt pour découvrir nos en-cas",
      noMenuAvailable: "Aucun menu disponible",
      comeBackSoonMenus: "Revenez bientôt pour découvrir nos menus",
    },
    en: {
      loadingRestaurants: "Loading snacks",
      loadingMenus: "Loading menus",
      noRestaurantsFound: "No snacks found",
      comeBackSoonRestaurants: "Come back soon to discover our snacks",
      noMenuAvailable: "No menu available",
      comeBackSoonMenus: "Come back soon to discover our menus",
    },
    ar: {
      loadingRestaurants: "جاري تحميل الوجبات الخفيفة",
      loadingMenus: "جاري تحميل القوائم",
      noRestaurantsFound: "لا توجد وجبات خفيفة",
      comeBackSoonRestaurants: "عد قريبًا لاكتشاف وجباتنا الخفيفة",
      noMenuAvailable: "لا توجد قائمة متاحة",
      comeBackSoonMenus: "عد قريبًا لاكتشاف قوائمنا",
    },
  },
}

/** @type {VenueMenusClientConfig} */
export const PETIT_DEJEUNER_VENUE_CONFIG = {
  venuesEndpoint: "/petit-dejeuners",
  pageContentPageName: "PetitDejeuner",
  reservationService: "petit_dejeuner",
  filterMenu: menuMatchesPetitDejeuner,
  labelOverrides: {
    fr: {
      loadingRestaurants: "Chargement du petit déjeuner",
      loadingMenus: "Chargement des menus",
      noRestaurantsFound: "Aucun petit déjeuner trouvé",
      comeBackSoonRestaurants: "Revenez bientôt pour découvrir nos petits déjeuners",
      noMenuAvailable: "Aucun menu disponible",
      comeBackSoonMenus: "Revenez bientôt pour découvrir nos menus",
    },
    en: {
      loadingRestaurants: "Loading breakfast",
      loadingMenus: "Loading menus",
      noRestaurantsFound: "No breakfast service found",
      comeBackSoonRestaurants: "Come back soon to discover our breakfast",
      noMenuAvailable: "No menu available",
      comeBackSoonMenus: "Come back soon to discover our menus",
    },
    ar: {
      loadingRestaurants: "جاري تحميل الإفطار",
      loadingMenus: "جاري تحميل القوائم",
      noRestaurantsFound: "لا يوجد إفطار",
      comeBackSoonRestaurants: "عد قريبًا لاكتشاف إفطارنا",
      noMenuAvailable: "لا توجد قائمة متاحة",
      comeBackSoonMenus: "عد قريبًا لاكتشاف قوائمنا",
    },
  },
}
